export const staticTextLookup = {
  treatmentsOverview: 'Wellness overview',
};
